import { render, staticRenderFns } from "./surveys.vue?vue&type=template&id=9a0922a0&lang=pug&"
import script from "./surveys.vue?vue&type=script&lang=js&"
export * from "./surveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports